import { FormControl } from '@angular/forms';
import { YesNoValue } from '@portal-workspace/grow-shared-library';
import { Subscription } from 'rxjs';

/**
 * Links the Asset Finance "Director Equifax score > 550" and "Equifax Director Score above 700"
 * yes/no controls. 700 = Yes forces 550 to Yes and locks it; 550 = No forces 700 to No.
 *
 * `canEnableAbove550` lets read-only views keep the 550 control disabled when 700 goes back to No.
 * Returns the subscriptions so the caller can tear them down.
 */
export const linkEquifaxDirectorScoreControls = (
  above550: FormControl<YesNoValue>,
  above700: FormControl<YesNoValue>,
  canEnableAbove550: () => boolean = () => true,
): Subscription[] => {
  const applyAbove700 = (value: YesNoValue) => {
    if (value) {
      above550.setValue(true, { emitEvent: false });
      above550.disable({ emitEvent: false });
    } else if (canEnableAbove550()) {
      above550.enable({ emitEvent: false });
    }
  };
  const subscriptions = [
    above700.valueChanges.subscribe(applyAbove700),
    above550.valueChanges.subscribe(value => {
      if (value === false) {
        above700.setValue(false, { emitEvent: false });
      }
    }),
  ];
  applyAbove700(above700.value);
  return subscriptions;
};
